import Konsys from 'modules/konsys-ui' // eslint-disable-line
import styled, { css, withTheme } from 'styled-components'
import { theme, media } from '../../styles/_variables'

const ButtonCus = styled(Konsys.Button)`
  > p {
    font-family: 'printAble4u';
    font-size: 18px;
  }
`
export const Button = withTheme(ButtonCus)
export const ButtonForm = styled(Button)`
  padding: 10px 32px 8px;
  box-shadow: 3px 3px 0 1px rgba(${theme.color.primaryColorRGB}, 0.7) !important;
  margin: ${props => (props.margin ? props.margin : '0 56px')}
  ${props => props.display && css`
    display: ${props.display};
  `}
  ${props => props.disabled && css`
    box-shadow: 3px 3px 0 1px rgba(${theme.color.primaryColorRGB}, 0.2) !important;
  `}
  ${media.tablet`
    /* margin: 0; */
    margin: ${props => (props.margin ? props.margin : 0)};
    padding: 8px 24px 4px;
  `}
  i {
    font-size: ${theme.fonts.size.extraNormal} !important;
    line-height: 1;
    opacity: 0.7;
    margin: ${props => (props.rightIcon ? '0 0 0 16px' : '0 16px 0 0')} !important;
    width: 25px;
    height: 25px;
    ${props => props.disabled && css`
      color: ${theme.color.primaryColor} !important;
      opacity: 0.2;
    `}
    ${media.tablet`
      font-size: ${theme.fonts.size.small} !important;
    `}
  }
  p,
  span {
    font-size: ${props => (props.fontSize ? props.fontSize : theme.fonts.size.subTitle)};
    line-height: 1;
    ${media.tablet`
      font-size: ${theme.fonts.size.extraNormal};
    `}
  }
  &:active {
    border: 1px solid ${theme.color.fourthColor};
    background-color: ${theme.color.fourthColor};
  }
  ${props => props.activeGreen && css`
    &:active {
      border: 1px solid ${theme.color.secondaryColor};
      background-color: ${theme.color.secondaryColor};
    }
  `}
`
export const SmallButtonForm = styled(ButtonForm)`
  padding: 4px 16px;
  p {
    font-size: ${theme.fonts.size.normal};
  }
`
export const Icon = withTheme(Konsys.Icon)
export const TextLink = withTheme(Konsys.TextLink)
export const P = withTheme(Konsys.P)
export const H1 = withTheme(Konsys.H1)
export const H2 = withTheme(Konsys.H2)
export const H3 = withTheme(Konsys.H3)
export const H4 = withTheme(Konsys.H4)
export const H5 = styled(Konsys.H4)`
  font-size: ${theme.fonts.size.extraNormal};
  font-family: 'printAble4u';
  color: ${props => props.color};
  ${props => props.bold && css`
    font-weight: ${theme.fonts.style.medium};
  `}
`
export const Label = withTheme(Konsys.Label)
export const SmallText = withTheme(Konsys.SmallText)
export const CheckboxGroup = withTheme(Konsys.CheckboxGroup)
export const RadioGroup = withTheme(Konsys.RadioGroup)
export const Loading = withTheme(Konsys.Loading)
export const Select = withTheme(Konsys.Select)
export const Collapse = withTheme(Konsys.Collapse)
export const LoadingIconCus = withTheme(Konsys.LoadingIcon)
export const LoadingIcon = styled(LoadingIconCus)`
  width: 20px;
  height: 20px;
`

export const InputWithLabel = withTheme(Konsys.InputWithLabel)
export const Input = withTheme(Konsys.Input)

export const Div = withTheme(Konsys.Div)

export const RadioCus = withTheme(Konsys.Radio)
export const RadioDefault = styled(RadioCus)`
  > label {
    > span {
    background-color: #FFFFFF;
    box-shadow: 1px 1px 0 1px rgba(${theme.color.primaryColorRGB}, 0.2);
    border: none;
      &:before {
        background-color: ${theme.color.lightBlack}
      }
    }
    > p {
      font-family: ${theme.fonts.family.normal};
      font-size: ${theme.fonts.size.extraNormal};
    }
  }
`
export const CheckboxCus = withTheme(Konsys.Checkbox)
export const CheckboxDefault = styled(CheckboxCus)`
  > label {
    > span {
      &::before {
        font-family: "Font Awesome 5 Pro";
      }
    }
  }
`

export const ButtoWhiteHoverGreen = styled(Button)`
  box-shadow: none !important;
  &:hover {
    background-color: ${theme.color.primaryColor};
    > p {
      color: ${theme.color.offWhite} !important;
    }
  }
  &:active {
    transition: none;
    background-color: ${theme.color.secondaryColor};
  }
`

export const ButtoGhostActiveWhite = styled(Button)`
  box-shadow: none !important;
  &:hover {
    border: 1px solid ${theme.color.primaryColor};
    background-color: ${theme.color.primaryColor};
    > p {
      color: ${theme.color.offWhite} !important;
    }
  }
  &:active {
    border: 1px solid ${theme.color.offWhite};
    background-color: ${theme.color.offWhite};
    transition: none;
    > p {
      color: ${theme.color.lightBlack} !important;
    }
  }
`

export const ButtonGreenHoverWhite = styled(Button)`
  box-shadow: none !important;
  &:hover {
    border: 1px solid ${theme.color.offWhite};
    background-color: ${theme.color.offWhite};
    > p {
      color: ${theme.color.lightBlack} !important;
    }
  }
  &:active {
    border: 1px solid ${theme.color.secondaryColor};
    background-color: ${theme.color.secondaryColor};
    transition: none;
    > p {
      color: ${theme.color.offWhite} !important;
    }
  }
`

export default Button



// WEBPACK FOOTER //
// ./src/components/common/konsys-ui.jsx